import React from 'react';
import { SkeletonComponent } from '@design-system';

export const UpdateCongeSkeleton: React.FC = () => {
    return (
        <div>
            {[...Array(1)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '348px',
                        width: 'calc(100% - 32px)',
                        margin: '16px auto',
                        borderRadius: '12px',
                        display: 'block'
                    }}
                />
            ))}
        </div>
    );
};
